const statusColors = { pending: "bg-yellow-600/20 text-yellow-400", confirmed: "bg-green-600/20 text-green-400", rejected: "bg-red-600/20 text-red-400" };
const statusText = { pending: "Afventer", confirmed: "Godkendt", rejected: "Afvist" };

const BookingsTab = ({ bookings, onUpdateStatus, onDelete, onReply, onNotes }) => {
  return (
    <div className="space-y-4">
      <h2 className="text-2xl font-['Oswald'] font-bold text-white mb-4">BOOKINGFORESPØRGSLER</h2>
      {bookings.length === 0 ? (
        <p className="text-gray-500 text-center py-8">Ingen bookingforespørgsler endnu</p>
      ) : (
        bookings.map((booking) => (
          <div key={booking.booking_id} className="mc-card p-6">
            <div className="flex flex-col lg:flex-row justify-between items-start gap-4">
              <div className="flex-1 space-y-3">
                <div className="flex items-center gap-3 flex-wrap">
                  <h3 className="text-xl font-bold text-white">{booking.name}</h3>
                  <span className={`px-3 py-1 rounded text-sm font-medium ${statusColors[booking.status]}`}>{statusText[booking.status]}</span>
                </div>
                <div className="grid sm:grid-cols-2 gap-x-8 gap-y-2 text-sm">
                  <p className="text-gray-400"><span className="text-gray-500">Email:</span> <span className="text-white">{booking.email}</span></p>
                  <p className="text-gray-400"><span className="text-gray-500">Telefon:</span> <span className="text-white">{booking.phone}</span></p>
                  <p className="text-gray-400"><span className="text-gray-500">Event:</span> <span className="text-blue-400">{booking.event_type}</span></p>
                  <p className="text-gray-400"><span className="text-gray-500">Dato:</span> <span className="text-white">{new Date(booking.event_date).toLocaleDateString("da-DK")}</span></p>
                  <p className="text-gray-400"><span className="text-gray-500">Tid:</span> <span className="text-white">{booking.start_time} - {booking.end_time}</span></p>
                  <p className="text-gray-400"><span className="text-gray-500">Inde/Ude:</span> <span className="text-white">{{ indoor: "Indendørs", outdoor: "Udendørs", both: "Indendørs + Udendørs" }[booking.venue_type] || booking.venue_type}</span></p>
                  {booking.address_street && <p className="text-gray-400"><span className="text-gray-500">Adresse:</span> <span className="text-white">{booking.address_street}, {booking.address_zip} {booking.address_city}</span></p>}
                  {booking.guest_count && <p className="text-gray-400"><span className="text-gray-500">Gæster:</span> <span className="text-white">{booking.guest_count}</span></p>}
                </div>
                {booking.description && <div className="bg-neutral-800/50 rounded-lg p-3"><p className="text-gray-300 text-sm">{booking.description}</p></div>}
                {booking.admin_reply && (
                  <div className="bg-green-900/20 border border-green-500/30 rounded-lg p-3">
                    <p className="text-green-400 text-xs mb-1">Besvaret</p>
                    <p className="text-gray-300 text-sm">{booking.admin_reply}</p>
                  </div>
                )}
              </div>
              <div className="flex flex-col gap-2 min-w-[140px]">
                {booking.status === "pending" && (
                  <>
                    <button onClick={() => onUpdateStatus(booking.booking_id, "confirmed")} className="bg-green-600 hover:bg-green-500 text-white px-4 py-2 rounded-lg text-sm" data-testid={`confirm-booking-${booking.booking_id}`}>Godkend</button>
                    <button onClick={() => onUpdateStatus(booking.booking_id, "rejected")} className="bg-red-600 hover:bg-red-500 text-white px-4 py-2 rounded-lg text-sm" data-testid={`reject-booking-${booking.booking_id}`}>Afvis</button>
                  </>
                )}
                <button onClick={() => onReply(booking)} className="chrome-btn px-4 py-2 rounded-lg text-sm">Besvar</button>
                <button onClick={() => onNotes(booking)} className="ghost-blue-btn px-4 py-2 rounded-lg text-sm">Noter</button>
                <button onClick={() => onDelete(booking.booking_id)} className="text-red-400 hover:text-red-300 px-4 py-2 text-sm">Slet</button>
              </div>
            </div>
          </div>
        ))
      )}
    </div>
  );
};

export default BookingsTab;
